let wanted = false;
let loading = false;
let stop: (() => void) | undefined;

export function syncSpookyTheme(enabled: boolean) {
  wanted = enabled;

  if (!enabled) {
    stop?.();
    stop = undefined;
    return;
  }

  if (stop || loading) {
    return;
  }

  loading = true;
  import(/* webpackChunkName: "spookyTheme" */ './startSpookyTheme')
    .then(({ startSpookyTheme }) => {
      if (wanted && !stop) {
        stop = startSpookyTheme();
      }
    })
    .catch(() => undefined)
    .finally(() => {
      loading = false;
    });
}
